export const SUBDOMAIN_STORAGE_KEY = "clinic_subdomain";

export function getStoredSubdomain() {
  return localStorage.getItem(SUBDOMAIN_STORAGE_KEY) || "";
}

export function setStoredSubdomain(subdomain) {
  if (subdomain) {
    localStorage.setItem(
      SUBDOMAIN_STORAGE_KEY,
      String(subdomain).trim().toLowerCase(),
    );
  }
}
